<template>
  <div class="min-h-full">

    <ApiNotification v-if="message" :message="message" :type="type" />
    <ModalErrorAcceso :showModal="showModalErrorAcceso" @close="loadModalErrorAcceso(false)"></ModalErrorAcceso>
    <ModalServiceUnavailable :showModal="showModalServiceUnavailable" @close="loadModalServiceUnavailable(false)">
    </ModalServiceUnavailable>
    <ModalUsuarios :showModal="showModalUsuarios" @close="loadModalUsuarios(false)"></ModalUsuarios>
    <ModalFormCambiaPass :showModal="showFormCambiaPass" @close="loadFormCambiaPass(false)"></ModalFormCambiaPass>



    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog as="div" class="relative z-40 lg:hidden" @close="sidebarOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
          enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
          leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-600 bg-opacity-75" />

        </TransitionChild>

        <div class="fixed inset-0 flex z-40">

          <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
            enter-from="-translate-x-10" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform"
            leave-from="translate-x-0" leave-to="-translate-x-10">
            <DialogPanel class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-cyan-700">

              <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                <div class="absolute top-0 right-0 -mr-12 pt-2">
                  <button type="button"
                    class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-inset focus:ring-white"
                    @click="sidebarOpen = false">
                    <span class="sr-only">Close sidebar</span>

                    <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </TransitionChild>
              <div class="flex-shrink-0 flex items-center px-4">

              </div>

              <SideBarMovilCliente v-if="pantalla !== 0" :navigation="navigation"
                :secondaryNavigation="secondaryNavigation" @chgIdPantalla="chgPantalla"
                @loadModalUsuarios="loadModalUsuarios" @loadModalErrorAcceso="loadModalErrorAcceso"
                @loadModalServiceUnavailable="loadModalServiceUnavailable"></SideBarMovilCliente>

              <SideBarMovilSettings @chgIdPantalla="chgPantalla" v-if="pantalla === 0"></SideBarMovilSettings>
            </DialogPanel>
          </TransitionChild>
          <div class="flex-shrink-0 w-14" aria-hidden="true">
            <!-- Dummy element to force sidebar to shrink to fit close icon -->
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->

    <SideBarDesktopCliente v-if="pantalla !== 0" :navigation="navigation" :secondaryNavigation="secondaryNavigation"
      :faenas="faenas" @chgIdPantalla="chgPantalla" @loadModalUsuarios="loadModalUsuarios"
      @loadModalErrorAcceso="loadModalErrorAcceso" @loadModalServiceUnavailable="loadModalServiceUnavailable">
    </SideBarDesktopCliente>

    <SideBarDesktopSettings @chgIdPantalla="chgPantalla" v-if="pantalla === 0"></SideBarDesktopSettings>

    <div class="lg:ml-[80px] flex flex-col flex-1">
      <div  class="relative z-10 flex-shrink-0 flex h-16 border-b  lg:border-none  ">

        <!-- Search bar -->
        <div class="flex-1 px-4 flex bg-gray-100">
          <div class="flex-1 flex items-center md:ml-0 font-mono  text-sm text-indigo-500">

            <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">
              &#60;HomeCliente&#62;
            </span>

            <span class="text-lg  text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">
              <h2 class="font-semibold tracking-wide ">
                BUDGET REWILDING CHILE </h2>
            </span>
            <span class="text-xs ml-3">
              {{ this.$store.state.auth.userLogin.nombres }} {{ this.$store.state.auth.userLogin.apellido1 }}
            </span>
          </div>
          <div class="ml-1 flex items-center md:ml-6 font-mono  text-sm text-indigo-500">
            <span class=" ml-4 text-white font-bold">
              <LogoRwc />
            </span>
            <Menu as="div" class="ml-5 relative">
              <div>


                <MenuButton
                  class="max-w-xs text-xs text-indigo-500 font-mono bg-indigo-50 px-3 rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 lg:p-2 lg:rounded-md lg:hover:bg-gray-50">
                  <span class="items-left hidden ml-3 text-gray-700 text-xs lg:block">
                    <span class="sr-only">abrir menu
                    </span>
                    Salir
                  </span>

                </MenuButton>
              </div>
              <transition enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                  class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">


                  <MenuItem v-slot="{ active }"><a href="/logout/"
                      :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700',]">{{
                        $t('cerrarsesion')}}</a>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
        <button type="button"
          class="px-4 border-r border-gray-200 text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500 lg:hidden"
          @click="sidebarOpen = true">
          <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
          <span class="sr-only">Open sidebar</span>

        </button>
      </div>
      <main class="flex-1 pb-8">
        <!-- Page header -->

        <div class="mt-1">
          <div class="mx-auto px-1 sm:px-1 lg:px-1">

            <div class="flex justify-start ">




            </div>

 
 
            <HomeSettings v-if="pantalla === 0"></HomeSettings>
            
            <MaestroCentros v-if="pantalla == 2" @chgCentro="chgCentro"
              @chgCentroCuentasMayorCero="chgCentroCuentasMayorCero"
              @chgCentroCuentasIncluidoCero="chgCentroCuentasIncluidoCero" @chgModifPresup="chgCentro"></MaestroCentros>

            <MaestroPlanCuentas v-if="pantalla == 3"></MaestroPlanCuentas>

            <IngresoPresupuestos v-if="pantalla == 4" :centro="centro"></IngresoPresupuestos>
        
            
            <CentroCuentasMayorCero v-if="pantalla == 5" :borrador="consulta_aa_borrador" :prop_obj_centro="centro"
              :centro_id="centro.id" :prop_incluyeCero="incluyeCero"></CentroCuentasMayorCero>
           
           
            <UploadLibroMayor v-if="pantalla == 6" :centro="centro"></UploadLibroMayor>
           
            <ListLibroMayor v-if="pantalla == 7" :centro="centro"></ListLibroMayor>
           
            <ReporteriaPresupuestos v-if="pantalla == 8" :borrador="false" />
           
            <UploadSolicitudes v-if="pantalla == 10" />

            <ReporteriaPresupuestos  v-if="pantalla == 11" :borrador="true" />
            
            <MaestroCentros v-if="pantalla == 12" :borrador="true" @chgCentro="chgCentro"
              @chgCentroCuentasMayorCero="chgCentroCuentasMayorCero"
              @chgCentroCuentasIncluidoCero="chgCentroCuentasIncluidoCero" @chgModifPresup="chgCentro"></MaestroCentros>
            
              <DownloadData v-if="pantalla == 1"  :aa="aa_actual">HOLA!!</DownloadData>
              <DownloadData v-if="pantalla == 13" :aa="aa_borrador">HOLA!!</DownloadData>


          </div>
        </div>

        <div v-if="isOnline == false" class="sticky bottom-0 bg-red-500 text-white text-center py-4"
          style='z-index:10000000'>
          <p>Sin conexión a la red</p>
        </div>
      </main>
      <footer>
        <span class="text-xs">
          Last built: <br />
          [{{ buildDate }}]


        </span>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import i18n from '@/i18n';



import { ref, onMounted, onUnmounted } from "vue";


import router from "../../router";
import { mapActions } from "vuex";

import {
  XIcon
} from "@heroicons/vue/outline";

import ApiNotification from "./modal/ApiNotification";
import SideBarMovilCliente from "../resumen/SideBarMovilCliente";
import SideBarDesktopCliente from "../resumen/SideBarDesktopCliente";
import LogoRwc from "../resumen/LogoRwc";





import SideBarDesktopSettings from "../settings/SideBarDesktopSettings";
import SideBarMovilSettings from "../settings/SideBarMovilSettings";

import HomeSettings from "../settings/HomeSettings";
import ModalUsuarios from "./modal/ModalUsuarios";
import ModalErrorAcceso from "./modal/ModalErrorAcceso";
import ModalFormCambiaPass from "./modal/ModalFormCambiaPass";
import ModalServiceUnavailable from "./modal/ModalServiceUnavailable"



import MaestroCentros from "../maestros/MaestroCentros";
import MaestroPlanCuentas from "../maestros/MaestroPlanCuentas";
import IngresoPresupuestos from "../presupuestos/IngresoPresupuestos";
import CentroCuentasMayorCero from "../presupuestos/CentroCuentasMayorCero";
import UploadLibroMayor from "../libromayor/UploadLibroMayor.vue";
import ListLibroMayor from "../libromayor/ListLibroMayor.vue";
import ReporteriaPresupuestos from "../presupuestos/ReporteriaPresupuestos.vue";
import DownloadData from "../presupuestos/DownloadData.vue"

import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,

} from "@headlessui/vue";
import UploadSolicitudes from "../presupuestos/UploadSolicitudes.vue";


export default
  {
    components:
    {
      ApiNotification,


      SideBarMovilCliente,
      SideBarDesktopCliente,


      Dialog,
      DialogPanel,
      Menu,
      MenuButton,
      MenuItem,
      MenuItems,
      TransitionChild,
      TransitionRoot,
      // BellIcon,
      XIcon,
      ModalUsuarios,
      ModalErrorAcceso,
      ModalFormCambiaPass,
      ModalServiceUnavailable,



      SideBarDesktopSettings,
      SideBarMovilSettings,
      HomeSettings,
      MaestroCentros,
      MaestroPlanCuentas,
      IngresoPresupuestos,
      CentroCuentasMayorCero,
      UploadLibroMayor,
      ListLibroMayor,
      ReporteriaPresupuestos,
      LogoRwc,
      DownloadData,
      UploadSolicitudes
    },

    created() {
      this.lang = i18n.global.locale.value;


      if (this.$store.state.tokens) {


        router.push("/");
        console.log("sin definir status login");
        return false;
      }


      this.checkInternet();
      window.addEventListener("online", this.checkInternet);
      window.addEventListener("offline", () => (this.isOnline = false));
    },
    beforeMount() {

      //console.log('user id',this.$store.state.auth.userLogin.id )
      if (typeof (this.$store.state.auth.userLogin.id) === "undefined" || this.$store.state.auth.userLogin.id == 0) {


        console.log("sin definir status login");
        location.href = "/";
        return false;
      }

    },
    mounted() {

      //console.log('user id',this.$store.state.auth.userLogin.id )
      if (typeof (this.$store.state.auth.userLogin.id) === "undefined" || this.$store.state.auth.userLogin.id == 0) {


        console.log("sin definir status login");
        location.href = "/";
        return false;
      }

      // this.user = this.$store.state.login.userLogin;
      //this.razonSocial =  this.user.info.razonSocial;
      this.pantalla = 2;

      if (this.datosUsuario.rol !== "Administrador") {
        this.adminNavigation = [];
      }


    },
    beforeUnmount() {
      window.removeEventListener("online", this.checkInternet);
      window.removeEventListener("offline", () => (this.isOnline = false));
    },
    methods: {
      ...mapActions("divisiones", ["getDivisionesApi"]),
      vertest() {
        router.push("/testmedicion")
      },
      async checkInternet() {
        try {

          await fetch("https://www.google.cl/", { mode: "no-cors" });
          this.isOnline = true;
        } catch (error) {
          this.isOnline = false;
        }
      },
      loadFormCambiaPass(valor) {
        this.showFormCambiaPass = valor;
      },


      loadModalUsuarios(valor) {
        console.log('loadModalUsuarios')
        this.showModalUsuarios = valor;
      },
      loadModalErrorAcceso(valor) {
        console.log('loadModalUsuarios')
        this.showModalErrorAcceso = valor;
      },
      loadModalServiceUnavailable(valor) {

        console.log('showModalServiceUnavailable')
        this.showModalServiceUnavailable = valor;
      },
      loadDivisiones(f) {
        this.selectDivisionesByIdFaena = f.id;
        this.nombreFaena = f.faena;
        this.pantalla = 2;
      },
      loadFaenas() {
        this.pantalla = 1;
      },
      loadFormCliente() {
        this.pantalla = 1;
      },
      chgPantalla(f) {

        this.pantalla = f.id;

        this.sidebarOpen = false;
      },

      sendDivisionesMenuLat(f) {
        this.faenas = f;
      },

      async sendPreference(jsonString) {
        console.log('sendPreferences');
        let url = '/api/ctl/setPreference';

        const apiKey = this.$store.state.login.tokenLogin;
        try {
          const resp = await axios.post(url, jsonString, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${apiKey}`
            },
          });

          let msg;
          const status = resp?.data?.status;
          switch (status) {
            case 200: msg = 'solicitud fetch ok'; break;
          }
          return msg;
        } catch (error) {
          console.log(error.responseJSON.message);
          throw error;
        }

      },

      chgCentro(value) {
        this.centro = value;
        this.pantalla = 4;
      },

      chgCentroCuentasMayorCero(v) {
        console.log(v)
        this.centro = v.centro
        this.pantalla = 5
        this.incluyeCero = false
        this.consulta_aa_borrador = v.consulta_aa_borrador

      },
      chgCentroCuentasIncluidoCero(value) {
        this.centro = value
        this.pantalla = 5
        this.incluyeCero = true
      }



    },

    data() {
      return {
        centro: {},

        imgbase64: '',
        isOnline: false,
        buildDate: process.env.BUILD_DATE,

        razonSocial: '',
        tokenseguridad: "",
        faenas: [{}],
        datosUsuario: {},
        pantalla: "",
        rol: "",
        selectDivisionesByIdFaena: 0,
        nombreFaena: "",
        navigation: [],
        numRam: 0,
        secondaryNavigation: [

          { name: i18n.global.t('cerrarsesion'), href: "/logout" },
        ],


        statusStyles: {
          success: "bg-green-100 text-green-800",
          processing: "bg-yellow-100 text-yellow-800",
          failed: "bg-gray-100 text-gray-800",
        },
        sidebarOpen: ref(false),
        jsonObject: {
          preference: {
            "global": {
              "mode": "",
              "color": ""
            },
            items: [],
            jaulas: []
          }
        },
        vistaLive: false,
        lang: '',
        showFormCambiaPass: false,
        showModalUsuarios: false,
        showModalServiceUnavailable: false,
        showModalErrorAcceso: false,
        message: false,
        consulta_aa_borrador: false,
        aa_borrador: this.$store.state.auth.userLogin.año_borrador,
        aa_actual: this.$store.state.auth.userLogin.año
      };
    },

    computed: {},
    setup() {
      const isSmallScreen = ref(window.innerWidth <= 768);
      const isPortrait = ref(window.matchMedia("(orientation: portrait)").matches);

      const updateScreenSize = () => {
        isSmallScreen.value = window.innerWidth <= 768;
      };

      const updateOrientation = () => {
        isPortrait.value = window.matchMedia("(orientation: portrait)").matches;
      };

      const updateAll = () => {
        updateScreenSize();
        updateOrientation();
      };

      onMounted(() => {
        window.addEventListener("resize", updateAll);
        window.addEventListener("orientationchange", updateAll);
      });

      onUnmounted(() => {
        window.removeEventListener("resize", updateAll);
        window.removeEventListener("orientationchange", updateAll);
      });

      return { isSmallScreen, isPortrait };
    },
    watch: {
      centro_id(value) {
        console.log('cambioo centro_id', value)
      },

    },
  };
</script>
